const pub = {
  "pub.whatsapp_default_msg": "Hallo, ich interessiere mich für eine Behandlung bei Esteva Clinic.",
  "pub.error_title": "Ein Fehler ist aufgetreten",
  "pub.error_message": "Bitte laden Sie die Seite neu. Falls das Problem weiterhin besteht, deaktivieren Sie bitte Browser-Übersetzung/Erweiterungen.",
  "pub.error_reload": "Seite neu laden",
  "pub.pill_1": "Zahnimplantate Albanien",
  "pub.pill_2": "Haartransplantation FUE",
  "pub.pill_3": "Nasenkorrektur Rhinoplastik",
  "pub.pill_4": "Brustvergrösserung",
  "pub.pill_5": "Facelifting",
  "pub.pill_6": "Liposuktion",
  "pub.pill_7": "Veneers Zirkonkronen",
  "pub.pill_8": "Botox Hyaluron",
  "pub.pill_9": "Bauchdeckenstraffung",
  "pub.pill_10": "Medical Tourism Albanien",
  "pub.pill_11": "70% günstiger als Schweiz",
  "pub.pill_12": "Premium Klinik Tirana",
  "pub.country_albania": "Albanien",
  "pub.opening_hours_default": "Mo–Fr: 08:00–20:00 | Sa: 09:00–16:00 | So: Geschlossen",
  "pub.fkw_1": "Zahnimplantate Albanien",
  "pub.fkw_2": "Zirkonkronen",
  "pub.fkw_3": "Veneers",
  "pub.fkw_4": "Zahnbleaching",
  "pub.fkw_5": "Haartransplantation FUE",
  "pub.fkw_6": "Brustvergrösserung Albanien",
  "pub.fkw_7": "Nasenkorrektur Rhinoplastik",
  "pub.fkw_8": "Botox Tirana",
  "pub.fkw_9": "Liposuktion Albanien",
  "pub.fkw_10": "Facelifting",
  "pub.fkw_11": "Bauchdeckenstraffung",
  "pub.fkw_12": "Bruststraffung",
  "pub.fkw_13": "Brustverkleinerung",
  "pub.fkw_14": "Augenlidkorrektur",
  "pub.fkw_15": "BBL Albanien",
  "pub.fkw_16": "Intimchirurgie",
  "pub.fkw_17": "Plastische Chirurgie Albanien",
  "pub.fkw_18": "Ästhetische Chirurgie Tirana",
  "pub.fkw_19": "Medizintourismus Albanien",
  "pub.fkw_20": "Dentaltourismus",
  "pub.fkw_21": "70% günstiger als Schweiz",
  "pub.fkw_22": "70% günstiger als Deutschland",
  "pub.fkw_23": "Zahnarzt im Ausland",
  "pub.fkw_24": "Premium Klinik Tirana",
  "pub.fkw_25": "Kostenlose Erstberatung",
};

export default pub;
